import { render, staticRenderFns } from "./time-span.vue?vue&type=template&id=1098e2c2"
import script from "./time-span.vue?vue&type=script&lang=ts"
export * from "./time-span.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports